// extracted by mini-css-extract-plugin
export default {"input-container":"InputBox_input-container__2qDAi","required":"InputBox_required__2PUg6","remove-icon":"InputBox_remove-icon__8wWgE","disabled":"InputBox_disabled__Jb9SQ"};